module.exports = __webpack_public_path__ + "cd4ac59d0a6e38d3502690d9930e7c51.svg";